import { render, staticRenderFns, recyclableRender, components } from "./simulation.vue?vue&type=template&id=2c4fe468&scoped=true&"
var renderjs
import script from "./simulation.vue?vue&type=script&lang=js&"
export * from "./simulation.vue?vue&type=script&lang=js&"
import style0 from "./simulation.vue?vue&type=style&index=0&id=2c4fe468&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4fe468",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/question-bank/simulation.vue"
export default component.exports